import React from "react";
import "../assets/css/legal-page.css";
import LegalNav from "../components/Legal/LegalNav";
import PolicyDetails from "../components/Legal/PolicyDetails";

const LegalPage = () => {
  return (
    <div className=" legal-page">
      <LegalNav />
      <PolicyDetails />
    </div>
  );
};

export default LegalPage;
